import "../../styles/menu.scss";
import CategoriesPC from "./Categories/CategoriesPC";
import HomeSection from "../../segmentedComponents/HomeSection";
import LoyaltySection from "../../segmentedComponents/LoyaltySection";
import React from "react";
import SecondaryMenu from "../../segmentedComponents/SecondaryMenu";
import { TrackingInfo } from "../tracking/TrackingInfoMenu";
import { BrandUtils } from "../../utils/brandUtils";
import { MenuWrapper } from "./MenuWrapper";

const Menu = () => (
  <MenuWrapper className="menu-pc">
    <LoyaltySection trackingInfo={TrackingInfo} />
    <HomeSection trackingInfo={TrackingInfo} />
    {!BrandUtils.isPokerClient() && (
      <CategoriesPC trackingInfo={TrackingInfo} />
    )}
    <SecondaryMenu trackingInfo={TrackingInfo} />
    <div className="backgroundCover" />
  </MenuWrapper>
);

export default React.memo(Menu);
